// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"checkbox-25F_b","label":"label-3DiqA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/form-controls/checkboxes/checkbox/checkbox.less
 ** module id = 171
 ** module chunks = 0
 **/